import {
  CLOSE_SG_DIALOG,
  OPEN_SG_DIALOG,
  SUBSCRIBE_SG_DIALOG_CLOSED,
  SUBSCRIBE_SG_DIALOG_OPENED,
  UNMOUNT_DIALOG
} from '../constants/sg-dialog';

export const openSGDialog = (id, payload) => ({ type: OPEN_SG_DIALOG, id, payload });
export const closeSGDialog = (id) => ({ type: CLOSE_SG_DIALOG, id });

export const subscribeSGDialogOpened = (id, onOpened) => ({
  type: SUBSCRIBE_SG_DIALOG_OPENED,
  id,
  onOpened
});

export const subscribeSGDialogClosed = (id, onClosed) => ({
  type: SUBSCRIBE_SG_DIALOG_CLOSED,
  id,
  onClosed
});

export const unmountDialog = (id) => ({
  type: UNMOUNT_DIALOG,
  id
});
